<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <v-btn class="compose-new-sms-button" color="accent" fab @click="onFabClick">
      <v-icon v-if="visible">mdi-chat</v-icon>
      <v-icon v-else>mdi-chat-plus-outline</v-icon>
    </v-btn>
    <v-overlay class="create-sms-overlay" :value="visible" absolute>
      <div class="create-sms-container" @click="onClickOutside">
        <div class="create-sms-content">
          <div v-once class="hidden-div">
            {{ $t('businessProcess') }}
          </div>
          <v-select
            hide-details
            class="mt-5"
            :items="businessProcesses"
            :label="$t('businessProcess')"
            :menu-props="{ bottom: true }"
            :value="selectedBusinessProcess"
            @click.stop
            @change="onBusinessProcessChange"
          ></v-select>
          <v-select
            hide-details
            class="mt-5"
            :items="availableDIDs"
            :label="$t('did')"
            :menu-props="{ bottom: true }"
            :value="selectedDID"
            :disabled="!allowChangeOutgoingDID"
            @click.stop
            @change="onSmsDIDChange"
          ></v-select>
          <v-text-field
            id="destination"
            ref="destination"
            autofocus
            type="number"
            class="mt-5"
            :rules="[isDestinationEmpty]"
            :label="$t('enterDestination')"
            :value="destination"
            @click.stop
            @change="onDestinationChange"
          ></v-text-field>
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InteractionService from '@/services/interactionService';
import { STATUS_SUCCESS } from '@/constants/appConstants';
export default {
  name: 'EcsCreateSms',
  props: {
    emailBusinessProcess: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      visible: false,
      selectedBusinessProcess: null,
      selectedDID: null,
      destination: ''
    };
  },

  computed: {
    ...mapGetters('BUSINESS_PROCESSES', ['availableBusinessProcesses']),

    ...mapGetters('REFERENCES', ['getSmsDetails']),

    ...mapGetters('SETTINGS', ['agentSettings']),

    businessProcesses() {
      return this.availableBusinessProcesses
        .filter(bp => bp.outgoingMediaTypes.includes('SMS'))
        .map(bp => {
          return { text: bp.name, value: bp.id };
        });
    },
    availableDIDs() {
      if (!this.selectedBusinessProcess) return [];
      return this.getSmsDetails(this.selectedBusinessProcess).map(did => did.did);
    },
    allowChangeOutgoingDID() {
      const defaultDID = this.getSmsDetails(this.selectedBusinessProcess).find(did => did.isDefault);
      if (defaultDID) {
        return defaultDID.allowAgentToSelectOutboundDIDForOutgoingInteractions;
      }
      return false;
    }
  },

  watch: {
    visible(newValue) {
      if (newValue) {
        this.selectedBusinessProcess = this.agentSettings.defaultOutgoingSmsBusinessProcessId;
        this.selectedDID = this.getDefaultDID(this.agentSettings.defaultOutgoingSmsBusinessProcessId);
      }
    },
    selectedBusinessProcess(newValue) {
      if (!newValue) return '';
      this.selectedDID = this.getDefaultDID(newValue);
    }
  },

  created() {
    this.$root.$on('open-create-sms', this.handleOpenCreateSms);
  },

  destroyed() {
    this.$root.$off('open-create-sms', this.handleOpenCreateSms);
  },

  methods: {
    getDefaultDID(businessProcessId) {
      const defaultDID = this.getSmsDetails(businessProcessId).find(did => did.isDefault === true);
      return defaultDID.did;
    },
    onBusinessProcessChange(value) {
      this.visible = true;
      this.selectedBusinessProcess = value;
    },
    onSmsDIDChange(value) {
      this.visible = true;
      this.selectedDID = value;
    },
    onDestinationChange(value) {
      this.destination = value;
    },
    async startSms() {
      if (!this.$refs.destination.valid) return;
      const errorMessage = this.$t('errorStartingSms');
      const response = await InteractionService.startSMSInteraction({
        businessProcessId: this.selectedBusinessProcess,
        destination: this.destination,
        outgoingDID: this.selectedDID
      }).catch(() => {
        this.$emit('emit-error-message', {
          errorMessage,
          type: 'error'
        });
      });
      if (response && response.status === STATUS_SUCCESS) {
        this.destination = '';
        this.visible = false;
      }
    },
    onClickOutside() {
      this.visible = false;
    },
    onFabClick() {
      if (!this.visible) {
        this.visible = true;
      } else {
        this.startSms();
      }
    },

    isDestinationEmpty(value) {
      return value.length > 0 || this.$t('emptyPhoneNumber');
    },
    handleOpenCreateSms(destination) {
      this.destination = destination;
      this.visible = true;
    }
  }
};
</script>

<style scoped>
.compose-new-sms-button {
  position: fixed;
  right: 12px;
  bottom: 60px;
  z-index: 10;
}
.hidden-div {
  height: 0;
  visibility: hidden;
  white-space: nowrap;
  font-size: 20px;
}
</style>
<style>
.create-sms-overlay .v-overlay__content,
.create-sms-container {
  height: 100%;
  width: 100%;
}
.create-sms-content {
  z-index: 10;
  position: absolute;
  bottom: 130px;
  right: 16px;
}
#destination::-webkit-outer-spin-button,
#destination::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
